
export default {
  interventions: [],
  interventionsHasInvoice: [],
  interventionsByArtisan: [],
  usersNbrsInterventions: [],
  historiquesByIntervention: [],
  interventionsDoesntHaveInvoice: []
}
